import React, { Component } from "react";
import ReactDataSheet from "react-datasheet";
import "react-datasheet/lib/react-datasheet.css";

import { debounce } from "lodash";
import { Loading } from "components";

class ImportProducts extends Component {
  state = {
    grid: [[{ value: "" }]],
    loading: this.props.loading,
  };

  constructor(props) {
    super(props);

    const { onImport } = props;

    this.handleSearch = debounce(onImport, 1000);
  }

  componentDidUpdate(oldProps) {
    const { loading } = this.props;

    if (oldProps.loading !== loading) {
      this.setState({ loading })
    }
  }

  handleCellsChanged = (changes, additions) => {
    const { grid } = this.state;

    if (!additions) {
      if (changes[0].row === grid.length - 1) {
        grid[changes[0].row + 1] = [{ value: "" }];
        this.setState({ grid });
      }
    }

    const newGrid = grid.map((row) => [...row]);

    changes.forEach(({ cell, row, col, value }) => {
      newGrid[row][col] = { ...newGrid[row][col], value };
    });

    if (additions) {
      additions.forEach(({ cell, row, col, value }) => {
        if (!newGrid[row]) {
          newGrid[row] = [{ value: "" }];
        }

        if (newGrid[row][col]) {
          newGrid[row][col] = { ...newGrid[row][col], value };
        }
      });
    }

    this.setState({ grid: newGrid });
  };

  handleDoubleClick = (onDoubleClick) => {
    alert(
      "Edição de célula ativa! clique uma vez apenas na célula para colar dados da planilha."
    );

    onDoubleClick();
  };

  handleImport = async (e) => {
    e.preventDefault();

    this.setState({ loading: true })

    const { grid } = this.state;
    const { name } = this.props;

    this.setState({ grid: [[{ value: "" }]] });

    await this.handleSearch(grid, name);
  };

  render() {
    const { grid, loading } = this.state;

    return (
      <div className="datasheet">
        <ReactDataSheet
          data={grid}
          valueRenderer={(cell) => cell.value}
          onCellsChanged={this.handleCellsChanged}
          sheetRenderer={(props) => (
            <table {...props}>
              <thead>
                <tr>
                  <td>SKU</td>
                </tr>
              </thead>
              <tbody>{props.children}</tbody>
            </table>
          )}
          cellRenderer={(props) => (
            <td
              onMouseDown={props.onMouseDown}
              onDoubleClick={() => this.handleDoubleClick(props.onDoubleClick)}
            >
              {props.children}
            </td>
          )}
        />

        <small>
          Para colar dados de uma planilha, clique apenas uma vez na célula e
          cole.
          <br />
          Para editar dados da célula, clique duas vezes.
        </small>

        <button type="button" className="button-import" onClick={this.handleImport}>
          {loading ? (
            <Loading type="btn" size="small" text="Importando..." style={{ marginTop: 0 }} />
          ) : (
            "Importar"
          )}
        </button>
      </div>
    );
  }
}

export default ImportProducts;
